import { lazy } from 'react';

export const VacanciesAsync = lazy(() => import('./vacancies.component'));
